import eotwJSXFactory from "base/eotwJSXFactory";
import handleNavigation from "navigation";
import {handleStickyNav} from "./util/handleStickyNav";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    handleNavigation();
    handleStickyNav();
});

(function () {

    const $accordions = $('.js-footer-accordions');

    if (!$accordions.length) return;

    $accordions.each((index, element) => {
        initFooterAccordion($(element));
    });

})();

function initFooterAccordion($element) {

    const BREAKPOINT = 768;
    let isActive = false;

    function enable() {
        if (isActive) return;

        $element.on('click.footerAccordion', '.js-footer-accordion-toggle', function () {
            const $toggle = $(this);
            const $accordion = $toggle.closest('.js-footer-accordion');

            $accordion.toggleClass('open');
        });

        isActive = true;
    }

    function disable() {
        if (!isActive) return;

        $element.off('.footerAccordion');
        $element.find('.js-footer-accordion').removeClass('open');

        isActive = false;
    }

    function check() {
        if (window.innerWidth < BREAKPOINT) {
            enable();
        } else {
            disable();
        }
    }

    check();

    $(window).on('resize.footerAccordion', check);
}

window.eotwJSXFactory = eotwJSXFactory;